import React, { useState } from 'react';
import PostHeader from '../post/PostHeader';
import PostActions from '../post/PostActions';
import CommentSection from '../post/CommentSection';
const APP_URL = "https://urchin-app-vijhz-lvk4i.ondigitalocean.app/api/v1";


const PostCard = ({
  post,
  currentUser,
  onLike,
  onDelete,
  onComment,
  comment,
  setComment,
  activeCommentPost,
  setActiveCommentPost,
  isLiking,
  isCommenting,
  isDeleting
}) => {
  const [isImageModalOpen, setIsImageModalOpen] = useState(false);

  const handleImageClick = () => {
    setIsImageModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsImageModalOpen(false);
  };

  return (
    <div className="bg-white rounded-2xl shadow-lg hover:shadow-xl transition-shadow duration-200 relative">
      <div className="p-6">
        {/* Post Header */}
        <PostHeader
          post={post}
          currentUser={currentUser}
          onDelete={onDelete}
          isDeleting={isDeleting}
        />

        {/* Post Content */}
        <div className="mb-4">
          <p className="text-gray-800 whitespace-pre-wrap leading-relaxed">
            {post.content}
          </p>
          {post.image && (
            <div className="mt-4 rounded-xl overflow-hidden cursor-pointer" onClick={handleImageClick}>
              <img
                src={`${post.image}`}
                alt="Post content"
                className="w-full max-h-96 object-cover hover:scale-105 transition-transform duration-200"
              />
            </div>
          )}
        </div>

        {/* Post Actions */}
        <PostActions
          post={post}
          onLike={onLike}
          isLiking={isLiking}
          activeCommentPost={activeCommentPost}
          setActiveCommentPost={setActiveCommentPost}
        />

        {/* Comment Section */}
        <CommentSection
          post={post}
          currentUser={currentUser}
          activeCommentPost={activeCommentPost}
          comment={comment}
          setComment={setComment}
          onComment={onComment}
          isCommenting={isCommenting}
        />
      </div>

      {/* Image Modal */}
      {isImageModalOpen && post.image && (
        <div 
          className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-90 p-4"
          onClick={handleCloseModal}
        >
          <div className="relative max-w-full max-h-full">
            {/* Close Button */}
            <button
              onClick={handleCloseModal}
              className="absolute top-4 right-4 z-10 bg-black bg-opacity-50 text-white p-2 rounded-full hover:bg-opacity-70 transition-all"
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
            
            {/* Image */}
            <img
              src={`${APP_URL}${post.image}`}
              alt="Post content"
              className="max-w-full max-h-full object-contain rounded-lg"
              onClick={(e) => e.stopPropagation()}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default PostCard; 